/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import { IObrienTabbedContainerViewProps } from './obrien-tabbed-container';



export const ObrienTabbedContainerView: React.FC<IObrienTabbedContainerViewProps> = props => {


    const { 
        tab1categories,
        tab2categories,
        tabTitle1,
        tabTitle2

    } = props;

    
    return (
        <div className='obrien-tabbed'>
            <Tabs defaultActiveKey="tab1" className="ob-tabs">
            {tab1categories ? (
                <Tab eventKey="tab1" title={tabTitle1}>
                    {tab1categories}
                </Tab>
            ) : null}
            {tab2categories ? (
                <Tab eventKey="tab2" title={tabTitle2}>
                    {tab2categories}
                </Tab>
            ) : null}
            </Tabs>
        </div>
    );
};

export default ObrienTabbedContainerView;